// extracted by mini-css-extract-plugin
export default {"container":"CampaignAd_container__esKjW","imageText":"CampaignAd_imageText__E1RD9","campaignShortName":"CampaignAd_campaignShortName__CxTtB"};